module.exports = __webpack_public_path__ + "media/images/flags/16/Zimbabwe-8141c706ee7356a8ebd6e72f5d20be7c.png";